<template>
	<Common>
		<template #half>
			<div class="fa">
				<div class="t1">
					Start with a detailed
					<span class="t11">description</span>
				</div>
				<AdComponent ref="ads-generate-1" :ads="adsensConfig.login_1" />
				<!-- <AdComponent ref="ads-generate-1" :ads="adsensConfig.generate_1" /> -->
				<div class="box">
					<el-input
						v-model="textarea"
						class="input"
						max="200"
						:maxlength="200"
						type="textarea"
						:rows="14"
						:placeholder="getPlaceHolder"
						resize="none"></el-input>
				</div>
				<Btn
					class="btnn fct"
					@clk="clk">
					<div class="in">
						<div class="t">Generate</div>
						<img
							src="@/assets/dia.png"
							alt="" />
						1
					</div>
				</Btn>
				<div
					class="t2 pointer"
					@click="showMsg">
					Upgrade for more credits
				</div>
			</div>
		</template>
	</Common>
</template>

<script>
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'

export default {
	name: 'Generate',
	mixins: [adMixin, adTrackingMixin],
	data() {
		return {
			textarea: '',
			arr: [`Red and blue collision of a phoenix embodving elemental forces of fire and water`, `cute minimalist desktop organizer background`, `in the style of pristine naturalism,white and light green, life force, forced perspective, graceful balance, resin,fujifilm natura 1600`, `Malika Favre's art of a woman looking shyly through very thin black ribbon,white background, minimalism in the style of a mix of pop art and optical art`],
		}
	},
	computed: {
		getPlaceHolder() {
			return this.arr[Math.floor(Math.random() * 4)]
		},
	},
	async activated() {
		console.log(`${this.$options.name} Component activated-----------`)
	},
	async mounted() {
		console.log(`-------------------${this.$options.name} mounted`)
		await this.initAdSystem()
		// 确保在广告系统初始化后再初始化跟踪
		this.$nextTick(() => {
			this.initAdTracking()
		})
	},
	deactivated() {
		this.textarea = ''
	},
	methods: {
		showMsg() {
			window.open('https://aitopupex.com/products/recharge-your-creativity-with-pixel-ai-lab', '_blank')
			// this.$message({
			// 	message: 'The page is under construction, launching soon.',
			// 	type: 'success',
			// 	duration: 3000,
			// })
		},
		clk() {
			this.$router.push({
				name: 'result',
				params: {
					text: this.textarea.length === 0 ? this.getPlaceHolder : this.textarea,
				},
			})
		},
	},
	metaInfo() {
		const description = `Generate unique images with AI. Customize your creative projects with ease at ${this.domainConfig.webUrl}.`
		return {
			title: 'Create images',
			meta: [
				{
					name: 'description',
					content: description,
				},
			],
		}
	},
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
	.fa {
		width: 75vw;
		margin: auto;
	}
}
.fa {
	padding-bottom: rem(60);
}
.t1 {
	margin-top: rem(70);
	margin-bottom: rem(52);
	color: #fff;
	text-align: center;
	font-family: 'Bakbak One';
	font-size: rem(40);
	font-style: normal;
	font-weight: 400;
	line-height: rem(40); /* 100% */
	.t11 {
		background: linear-gradient(96deg, #3cca7c 0%, #28c5c2 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-family: 'Bakbak One';
		font-size: rem(40);
		font-style: normal;
		font-weight: 400;
		line-height: rem(40);
	}
}
.t2 {
	background: linear-gradient(96deg, #3cca7c 0%, #28c5c2 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	text-align: center;
	font-family: 'Bakbak One';
	font-size: rem(20);
	font-style: normal;
	font-weight: 400;
	line-height: rem(20); /* 100% */
	text-decoration-line: underline;
	text-decoration-style: solid;
	text-decoration-skip-ink: none;
	text-decoration-thickness: auto;
	text-underline-offset: auto;
	text-underline-position: from-font;
	margin-bottom: rem(80);
}
.box {
	// height: rem(500);
	.input {
		// height: 100%;
		font-size: 20px;
	}
}
.btnn {
	margin: rem(58) auto rem(52);
}
.in {
	img {
		width: rem(40);
		margin: 0 8px;
	}
	display: flex;
	align-items: center;
}
@media screen and (orientation: portrait) {
	.t1 {
		font-size: rem(58);
		line-height: rem(68);
		.t11 {
			font-size: rem(58);
			line-height: rem(68);
		}
	}
	.box {
		padding: rem(20);
	}
}
</style>
